module.exports = __webpack_public_path__ + "img/danLED.63ae8672.png";